import { FlexColumn } from '@gorila-shared-ui/components';
import { ConfigurationOverride } from 'baseui/helpers/overrides';
import { LabelSmall } from 'baseui/typography';
import React from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { StyledCard } from '../styledCard/StyledCard';
import { StyledCardBodyWrapper } from '../styledCard/StyledCardBodyWrapper';
import { StyledCardDivider } from '../styledCard/StyledCardDivider';
import { StyledCardHeaderWrapper } from '../styledCard/StyledCardHeaderWrapper';

type Props = Readonly<{
  label: string | React.ReactNode;
  children: React.ReactNode;
  rootStyleOverrides?: ConfigurationOverride;
  alwaysShowContent?: boolean;
}>;

function LabeledDataCard({ label, children, rootStyleOverrides, alwaysShowContent = true }: Props) {
  const { css, theme } = useStyles();

  return (
    <StyledCard rootStyleOverrides={{ overflow: alwaysShowContent ? 'visible' : undefined, ...rootStyleOverrides }}>
      <StyledCardHeaderWrapper
        classNames={css({
          padding: `${theme.sizing.scale300} ${theme.sizing.scale600}`,
          backgroundColor: theme.colors.backgroundSecondary,
        })}
      >
        {typeof label === 'string' && <LabelSmall>{label}</LabelSmall>}
        {typeof label !== 'string' && label}
      </StyledCardHeaderWrapper>
      <StyledCardDivider />
      <StyledCardBodyWrapper
        classNames={css({
          padding: `${theme.sizing.scale400} ${theme.sizing.scale600} ${theme.sizing.scale600}`,
        })}
      >
        <FlexColumn gap={0}>{children}</FlexColumn>
      </StyledCardBodyWrapper>
    </StyledCard>
  );
}

export default LabeledDataCard;
